import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import Button from "./Button";
import Card from "./Card";
import { validateSignUpForm } from "./Validate";
import Dropdown from "./DropDown";
import axios from "axios";

const SignUp = () => {
  const [loms, setLoms] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [formData, setFormData] = useState({
    membershipId: "",
    name: "",
    phone: "",
    whatsapp_no: "",
    trainerZoneXVIII: "",
    organization_name: "",
    highest_portfolio: "",
    highest_position_training: "",
    dob: "",
    district: "",
    year: "",
    lomId: "", // New property to store lom_id
  });

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDropdownChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      district: field === "trainerZoneXVIII" ? "" : prev.district,
    }));
  };

  const fetchDistrictOptions = async () => {
    try {
      const zoneValue = formData.trainerZoneXVIII;
      const response = await axios.get(
        `/zone_district/read_zone_18?zone_18=${zoneValue}`
      );
      const districts = response.data.map((district) => district.district_name);
      setDistrictOptions(districts);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistrictOptions([]);
    }
  };

  useEffect(() => {
    if (formData.trainerZoneXVIII) {
      fetchDistrictOptions();
    }
  }, [formData.trainerZoneXVIII]);

  useEffect(() => {
    axios
      .get("/lom/read")
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];
        setLoms(data);
      })
      .catch((error) => console.error("Error fetching LOMs:", error));
  }, []);

  const handleGetOtp = async (e) => {
    e.preventDefault();

    // Validate the form inputs
    const validationErrors = validateSignUpForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      // Make the API call to store the form data in the `zone_trainer` table
      const response = await axios.post(
        "/zone_trainer/add_zone_trainer",
        formData
      );

      // Check for a successful response
      if (response.status === 201) {
        console.log("Trainer added successfully:", response.data);

        // Navigate to the OTP sign-up page
        navigate("/OtpSignup", {
          state: {
            phone: formData.phone, // Pass phone to OTP sign-up page
          },
        });
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error adding trainer:", error);
      alert("Failed to add trainer. Please try again.");
    }
  };

  return (
    <div className="relative min-h-screen bg-gray-100">
      <img
        src={`${process.env.PUBLIC_URL}/bg_image.jpg`}
        alt="Background"
        className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
      <div className="relative min-h-screen flex items-center justify-center z-20">
        <Card className="w-full max-w-3xl p-6 bg-white shadow-lg rounded-lg">
          <img
            src={`${process.env.PUBLIC_URL}/jci_logo.png`}
            alt="Logo"
            className="w-24 mx-auto mb-6"
          />
          <h2 className="card-header text-center text-2xl font-semibold mb-6">
            Signup to create an account
          </h2>
          <form onSubmit={handleGetOtp} className="space-y-6">
            <Dropdown
              label="Trainer from Zone XVIII (18)"
              name="trainerZoneXVIII"
              value={formData.trainerZoneXVIII || ""}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              onChange={(event) =>
                handleDropdownChange("trainerZoneXVIII", event.target.value)
              }
              required
            />
            {formData.trainerZoneXVIII === "Yes" && (
              <div className="mb-4">
                <label className="block mb-2">
                  District<span className="text-red-600"> *</span>
                </label>
                <select
                  name="district"
                  value={formData.district}
                  onChange={(event) =>
                    handleChange({
                      target: { name: "district", value: event.target.value },
                    })
                  }
                  required
                  className="border rounded p-2 w-full"
                >
                  <option value="" disabled>
                    Select a district
                  </option>
                  {districtOptions.map((district) => (
                    <option key={district} value={district}>
                      {district}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {formData.trainerZoneXVIII === "No" && (
              <div className="mb-4">
                <label className="block mb-2">
                  District<span className="text-red-600"> *</span>
                </label>
                <input
                  list="district-options"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  className="border rounded p-2 w-full"
                  placeholder="Select or type a district"
                />
                <datalist id="district-options">
                  {districtOptions.map((district) => (
                    <option key={district} value={district}>
                      {district}
                    </option>
                  ))}
                </datalist>
              </div>
            )}
            <InputField
              label="Name with Title"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Dr. S. Jashan"
              required
              error={errors.name}
            />
            <InputField
              label="JCI Membership ID"
              type="text"
              name="membershipId"
              value={formData.membershipId}
              onChange={handleChange}
              placeholder="37"
              required
              error={errors.membershipId}
            />
            <div className="mb-4">
              <label className="block mb-2">
                LO<span className="text-red-600"> *</span>
              </label>
              <select
                id="lomDropdown"
                className="border rounded p-2 w-full"
                value={formData.lomId}
                onChange={(event) =>
                  setFormData({ ...formData, lomId: event.target.value })
                }
                required
              >
                <option value="">-- Select an Option --</option>
                {loms.map((lom) => (
                  <option key={lom.lom_id} value={lom.lom_id}>
                    {lom.lom_name}
                  </option>
                ))}
              </select>
            </div>
            <InputField
              label="Highest Portfolio in JCI"
              type="text"
              name="highest_portfolio"
              value={formData.highest_portfolio}
              onChange={handleChange}
              placeholder="Portfolio"
              required
              error={errors.highest_portfolio}
            />
            <Dropdown
              label="Portfolio Year"
              name="year"
              value={formData.year || ""}
              options={Array.from({ length: 50 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return { label: year, value: year };
              })}
              onChange={(event) =>
                handleDropdownChange("year", event.target.value)
              }
              required
            />

            <Dropdown
              label="Highest Position in Training"
              name="highest_position_training"
              value={formData.highest_position_training}
              options={[
                { label: "Select Position", value: "" },
                { label: "State Trainer", value: "State Trainer" },
                { label: "Corporate Trainer", value: "Corporate Trainer" },
                { label: "JCI Designer", value: "JCI Designer" },
                { label: "JCI Author", value: "JCI Author" },
                { label: "Excel Graduate", value: "Excel Graduate" },
                {
                  label: "Academy of Business Coach",
                  value: "Academy of Business Coach",
                },
                {
                  label: "Provisional Zone Trainer",
                  value: "Provisional Zone Trainer",
                },
                { label: "National Trainer", value: "National Trainer" },
                { label: "Zone Trainer", value: "Zone Trainer" },
              ]}
              onChange={(event) =>
                handleDropdownChange(
                  "highest_position_training",
                  event.target.value
                )
              }
              required
            />
            {errors.highest_position_training && (
              <span>{errors.highest_position_training}</span>
            )}

            <InputField
              label="Date of Birth"
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
              error={errors.dob}
            />
            <InputField
              label="Whatsapp Number"
              type="text"
              name="whatsapp_no"
              value={formData.whatsapp_no}
              onChange={handleChange}
              placeholder="9087562345"
              required
              error={errors.whatsapp_no}
            />
            <InputField
              label="Contact Number"
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="9087562345"
              required
              error={errors.phone}
            />
            <div className="text-center mt-6">
              <Button label="GET OTP" type="submit" />
              <p className="mt-4">
                Already have an account?{" "}
                <Link to="/" className="text-blue-500 font-bold">
                  Login
                </Link>
              </p>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default SignUp;
